/**
 * Returns `true` if `x` is less than `y`.
 *
 * @param {number|string} x
 * @param {number|string} y
 * @returns {boolean}
 */
export function lt(x, y) {
  return Number(x) < Number(y);
}
